"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get LatestVitalsResponseSchema () {
        return LatestVitalsResponseSchema;
    },
    get LatestVitalsSchema () {
        return LatestVitalsSchema;
    },
    get LatestVitalsSourceSchema () {
        return LatestVitalsSourceSchema;
    }
});
const _zod = require("zod");
const _encounterstatus = require("./encounter-status");
const isoDateTime = ()=>_zod.z.string().datetime({
        offset: true
    });
const LatestVitalsSourceSchema = _zod.z.discriminatedUnion('kind', [
    _zod.z.object({
        kind: _zod.z.literal('encounter'),
        encounterId: _zod.z.string().uuid(),
        encounterNo: _zod.z.string().regex(/^ENC-\d{6,}$/, {
            message: 'Invalid encounter number.'
        }),
        status: _encounterstatus.EncounterStatusSchema
    }).strict(),
    _zod.z.object({
        kind: _zod.z.literal('fpe'),
        status: _zod.z.enum([
            'draft',
            'completed'
        ])
    }).strict()
]);
const LatestVitalsSchema = _zod.z.object({
    bpSystolic: _zod.z.number().int().nullable(),
    bpDiastolic: _zod.z.number().int().nullable(),
    heartRate: _zod.z.number().int().nullable(),
    respiratoryRate: _zod.z.number().int().nullable(),
    temperatureC: _zod.z.number().nullable(),
    weightKg: _zod.z.number().nullable(),
    heightCm: _zod.z.number().nullable(),
    bmi: _zod.z.number().nullable(),
    recordedAt: isoDateTime(),
    source: LatestVitalsSourceSchema
}).strict();
const LatestVitalsResponseSchema = _zod.z.object({
    vitals: LatestVitalsSchema.nullable()
}).strict();
